import { render, staticRenderFns } from "./SelectorMenuItem.vue?vue&type=template&id=682bcb7c&scoped=true"
import script from "./SelectorMenuItem.vue?vue&type=script&lang=js"
export * from "./SelectorMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SelectorMenuItem.vue?vue&type=style&index=0&id=682bcb7c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682bcb7c",
  null
  
)

export default component.exports